import styled, { css } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { FiltersIcon } from '@/components/UI/Icons/Icons';

export const SearchPanelBox = styled.div<{ $isHomePage: boolean }>`
  display: flex;
  gap: 5px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.primary.background};
  padding: 15px;
  position: relative;
  z-index: 10;

  ${({ $isHomePage, theme }) =>
    $isHomePage &&
    !theme.isWebView &&
    css`
      padding-top: 0;
    `}

  @media (min-width: 950px) {
    top: 0;
    gap: 0;
    margin-right: 20px;
    padding: 14px 0;
    z-index: auto;
  }
`;

export const SearchPanelFiltersBtn = styled(Button).attrs({
  appearance: 'primaryOutlined',
  shape: 'square',
  height: 44,
  borderRadius: 14,
})``;

export const SearchPanelFiltersBtnIcon = styled(FiltersIcon).attrs(
  ({ theme }) => ({
    fill: theme.palette.brand.main,
  })
)``;
